import { render, staticRenderFns } from "./items-type-material.vue?vue&type=template&id=0dadb912&scoped=true&"
import script from "./items-type-material.vue?vue&type=script&lang=js&"
export * from "./items-type-material.vue?vue&type=script&lang=js&"
import style0 from "./items-type-material.vue?vue&type=style&index=0&id=0dadb912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadb912",
  null
  
)

export default component.exports